import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ICommission} from 'types/project';
import {ResponseData} from 'types/response-data';

const getProjectCommissions = api.injectEndpoints({
  endpoints: builder => ({
    getProjectCommissions: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `projects/${params.id}/commissions`,
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<Array<ICommission>>;

export const {useGetProjectCommissionsQuery} = getProjectCommissions;
